<ng-container [ngSwitch]="hostLoading">
  <awair-loading-icon *ngSwitchCase="true"
                      [isBlack]="true"></awair-loading-icon>
  <ng-content *ngSwitchDefault></ng-content>
</ng-container>
